<app-add-ethnic-group></app-add-ethnic-group>

<div class="relative container mx-auto my-8 flex flex-col">
  <div class="flex justify-between">
    <h2 class="pb-4 text-3xl text-zinc-900 dark:text-zinc-200">
      {{ type }} Ethnic Group Table
    </h2>
    <div>
      <button *ngIf="
          (type === 'Current' && !allCurrentEthnicGroupsReviewed) ||
          (type === 'Future' && !allFutureEthnicGroupsReviewed)
        "
        class="rounded-lg bg-cam-orange px-3 py-2 font-semibold text-white transition duration-100 hover:scale-105 hover:cursor-pointer"
        (click)="setEthnicGroupsToReviewed()">
        Mark all Reviewed
      </button>
    </div>
  </div>
  <div *ngIf="
      (type === 'Current' && !allCurrentEthnicGroupsReviewed) ||
      (type === 'Future' && !allFutureEthnicGroupsReviewed)
    " class="mb-4 flex">
    <p class="rounded-lg bg-amber-200 px-2 py-1 text-lg">
      Please review each Ethnic Group and update or confirm the information
      below to complete this section.
    </p>
  </div>
  <div *ngIf="ethnics.length === 0" class="mb-4 flex items-center gap-2">
    <input 
      type="checkbox" 
      id="notApplicable"
      [(ngModel)]="notApplicable"
      (change)="onNotApplicableChange()"
      class="h-4 w-4 rounded border-zinc-300 text-cam-blue focus:ring-cam-blue"
    />
    <label for="notApplicable" class="text-zinc-900 dark:text-zinc-200">
      Not Applicable - I do not have any {{ type.toLowerCase() }} ethnic groups
    </label>
  </div>
  <form [formGroup]="ethnicGroupForm" (ngSubmit)="onSubmit()" class="mb-4">
    <div class="overflow-x-auto">
      <table class="table-auto border-separate border border-zinc-600">
        <thead class="bg-zinc-300 dark:bg-zinc-700">
          <tr>
            <th *ngFor="let head of headers" scope="col" class="border border-zinc-600 px-2 py-1 dark:border-white/10">
              <div class="flex items-center gap-2">
                <span class="leading-none">
                  {{ head }}
                </span>
                <app-table-sort *ngIf="head !== 'Actions'" [deselected]="activeHeaderSort !== head"
                  (sorting)="sortTable($event, head)"></app-table-sort>
              </div>
            </th>
          </tr>
        </thead>
        <ng-container *ngIf="ethnics.length > 0">
          <tbody *ngIf="ethnics.length > 0; else noItems">
            <tr *ngFor="
                let ethnic of ethnics
                  | paginate: { itemsPerPage: 10, currentPage: p }
              " [class.bg-amber-200]="ethnic.Action === 'U'">
              <!-- Ethnic Group -->
              <td>
                {{ ethnic.Name }}
              </td>

              <!-- Language -->
              <td *ngIf="
              !editState ||
              (editState &&
                itemToEdit.EthnicGroupID !== ethnic.EthnicGroupID)
            ">
                {{ ethnic.Language || '' }}
              </td>
              <td *ngIf="
                editState && itemToEdit.EthnicGroupID == ethnic.EthnicGroupID
              ">
                <input *ngIf="!submitted || ethnicGroupForm.get('Language')?.valid" formControlName="Language"
                  (blur)="onFieldBlur('Language')"
                  class="w-[9.875rem] self-start rounded-lg border px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden" />
                <!-- was being used by above input
                  [ngClass]="{
                  'bg-[#f8cfcffa]':
                    ethnicGroupForm.get('Language')?.value === null ||
                    ethnicGroupForm.get('Language')?.value === undefined ||
                    ethnicGroupForm.get('Language')?.value === '',
                }"
                  
                     -->
                <div *ngIf="submitted && !ethnicGroupForm.get('Language')?.valid" data-tip="Enter a valid language">
                  <input formControlName="Language" type="text"
                    class="w-[9.875rem] self-start rounded-lg border bg-[#f8cfcffa] px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden" />
                </div>
              </td>


              <!-- Location -->
              <td *ngIf="
                  !editState ||
                  (editState &&
                    itemToEdit.EthnicGroupID !== ethnic.EthnicGroupID)
                ">
                {{ ethnic.Location || '' }}
              </td>
              <td *ngIf="
                  editState && itemToEdit.EthnicGroupID == ethnic.EthnicGroupID
                ">
                <input *ngIf="!submitted || ethnicGroupForm.get('Location')?.valid" formControlName="Location"
                  (blur)="onFieldBlur('Location')"
                  class="w-[9.875rem] self-start rounded-lg border px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden" />

                <!-- was being used by above input 
                    [ngClass]="{
                    'bg-[#f8cfcffa]':
                      ethnicGroupForm.get('Location')?.value === null ||
                      ethnicGroupForm.get('Location')?.value === undefined ||
                      ethnicGroupForm.get('Location')?.value === '',
                  }"
                 -->

                <div *ngIf="submitted && !ethnicGroupForm.get('Location')?.valid" data-tip="Enter a valid location">
                  <input formControlName="Location" type="text"
                    class="w-[9.875rem] self-start rounded-lg border bg-[#f8cfcffa] px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden" />
                </div>
              </td>

              <!-- State -->
              <td>
                {{
                ethnic.Action == "A"
                ? "New"
                : ethnic.Action == "E"
                ? "Edited"
                : ethnic.Action == "R"
                ? "Reviewed"
                : ethnic.Action == "D"
                ? "Deleted"
                : "Unchanged"
                }}
              </td>

              <!-- Workers -->
              <td *ngIf="
                  !editState ||
                  (editState &&
                    itemToEdit.EthnicGroupID !== ethnic.EthnicGroupID)
                ">
                {{ ethnic.Workers | numberFormat }}
              </td>
              <td *ngIf="
                  editState && itemToEdit.EthnicGroupID == ethnic.EthnicGroupID
                ">
                <input *ngIf="!submitted || ethnicGroupForm.get('Workers')?.valid" appNumberFormat
                  formControlName="Workers"
                  (blur)="onFieldBlur('Workers')"
                  class="w-20 self-start rounded-lg border px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
                  [ngClass]="{
                    'bg-[#f8cfcffa]': isValueEmpty(ethnicGroupForm.get('Workers')?.value),
                  }" />
                <div *ngIf="submitted && !ethnicGroupForm.get('Workers')?.valid" data-tip="Enter a valid number">
                  <input appNumberFormat formControlName="Workers"
                    class="w-20 self-start rounded-lg border bg-[#f8cfcffa] px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden" />
                </div>
                <span *ngIf="fieldErrors['Workers']" class="mt-1 block text-sm text-cam-red">
                  {{ fieldErrors['Workers'] }}
                </span>
              </td>

              <!-- CAM Supported Workers -->
              <td *ngIf="
                  (!editState && type == 'Current') ||
                  (editState &&
                    itemToEdit.EthnicGroupID !== ethnic.EthnicGroupID &&
                    type == 'Current')
                ">
                {{ ethnic.WorkersBenefitted | numberFormat }}
              </td>
              <td *ngIf="
                  editState &&
                  type == 'Current' &&
                  itemToEdit.EthnicGroupID == ethnic.EthnicGroupID
                ">
                <input *ngIf="
                    !submitted ||
                    ethnicGroupForm.get('WorkersBenefitted')?.valid
                  " appNumberFormat formControlName="WorkersBenefitted" size="5"
                  (blur)="onFieldBlur('WorkersBenefitted')"
                  class="w-20 self-start rounded-lg border px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
                  [ngClass]="{
                    'bg-[#f8cfcffa]': isValueEmpty(ethnicGroupForm.get('WorkersBenefitted')?.value),
                  }" />
                <div *ngIf="
                    submitted &&
                    !ethnicGroupForm.get('WorkersBenefitted')?.valid
                  " data-tip="Enter a valid number">
                  <input appNumberFormat formControlName="WorkersBenefitted" size="5"
                    class="w-20 self-start rounded-lg border bg-[#f8cfcffa] px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden" />
                </div>
                <span *ngIf="fieldErrors['WorkersBenefitted']" class="mt-1 block text-sm text-cam-red">
                  {{ fieldErrors['WorkersBenefitted'] }}
                </span>
              </td>

              <!-- Churches -->
              <td *ngIf="
                  (!editState && type == 'Current') ||
                  (editState &&
                    itemToEdit.EthnicGroupID !== ethnic.EthnicGroupID &&
                    type == 'Current')
                ">
                {{ ethnic.Churches | numberFormat }}
              </td>
              <td *ngIf="
                  editState &&
                  type == 'Current' &&
                  itemToEdit.EthnicGroupID == ethnic.EthnicGroupID
                ">
                <input *ngIf="!submitted || ethnicGroupForm.get('Churches')?.valid" appNumberFormat
                  formControlName="Churches" size="5"
                  (blur)="onFieldBlur('Churches')"
                  class="w-20 self-start rounded-lg border px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
                  [ngClass]="{
                    'bg-[#f8cfcffa]': isValueEmpty(ethnicGroupForm.get('Churches')?.value),
                  }" />
                <div *ngIf="submitted && !ethnicGroupForm.get('Churches')?.valid" data-tip="Enter a valid number">
                  <input appNumberFormat formControlName="Churches" size="5"
                    class="w-20 self-start rounded-lg border bg-[#f8cfcffa] px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden" />
                </div>
                <span *ngIf="fieldErrors['Churches']" class="mt-1 block text-sm text-cam-red">
                  {{ fieldErrors['Churches'] }}
                </span>
              </td>

              <!-- Believers -->
              <td *ngIf="
                  (!editState && type == 'Current') ||
                  (editState &&
                    itemToEdit.EthnicGroupID !== ethnic.EthnicGroupID &&
                    type == 'Current')
                ">
                {{ ethnic.Believers | numberFormat }}
              </td>
              <td *ngIf="
                  editState &&
                  type == 'Current' &&
                  itemToEdit.EthnicGroupID == ethnic.EthnicGroupID
                ">
                <input *ngIf="!submitted || ethnicGroupForm.get('Believers')?.valid" formControlName="Believers"
                  size="5" appNumberFormat
                  (blur)="onFieldBlur('Believers')"
                  class="w-20 self-start rounded-lg border px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
                  [ngClass]="{
                    'bg-[#f8cfcffa]': isValueEmpty(ethnicGroupForm.get('Believers')?.value),
                  }" />
                <div *ngIf="submitted && !ethnicGroupForm.get('Believers')?.valid" data-tip="Enter a valid number">
                  <input appNumberFormat formControlName="Believers" size="5"
                    class="w-20 self-start rounded-lg border bg-[#f8cfcffa] px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden" />
                </div>
                <span *ngIf="fieldErrors['Believers']" class="mt-1 block text-sm text-cam-red">
                  {{ fieldErrors['Believers'] }}
                </span>
              </td>

              <!-- Monthly Cost per Worker -->
              <td *ngIf="
                  (!editState && type == 'Future') ||
                  (editState &&
                    itemToEdit.EthnicGroupID !== ethnic.EthnicGroupID &&
                    type == 'Future')
                ">
                {{ ethnic.AmountPerWorker | numberFormat }}
              </td>
              <td *ngIf="
                  editState &&
                  type == 'Future' &&
                  itemToEdit.EthnicGroupID == ethnic.EthnicGroupID
                ">
                <input *ngIf="
                    !submitted || ethnicGroupForm.get('AmountPerWorker')?.valid
                  " appNumberFormat [allowDecimals]="true" formControlName="AmountPerWorker" size="5"
                  (blur)="onFieldBlur('AmountPerWorker')"
                  class="w-20 self-start rounded-lg border px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
                  [ngClass]="{
                    'bg-[#f8cfcffa]': isValueEmpty(ethnicGroupForm.get('AmountPerWorker')?.value),
                  }" />
                <div *ngIf="
                    submitted && !ethnicGroupForm.get('AmountPerWorker')?.valid
                  " data-tip="Enter a valid number">
                  <input appNumberFormat [allowDecimals]="true" formControlName="AmountPerWorker" size="5"
                    class="w-20 self-start rounded-lg border bg-[#f8cfcffa] px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden" />
                </div>
                <span *ngIf="fieldErrors['AmountPerWorker']" class="mt-1 block text-sm text-cam-red">
                  {{ fieldErrors['AmountPerWorker'] }}
                </span>
              </td>

              <!-- Year -->
              <td *ngIf="
                  !editState ||
                  (editState &&
                    itemToEdit.EthnicGroupID !== ethnic.EthnicGroupID)
                ">
                {{ ethnic.Year }}
              </td>
              <td *ngIf="
                  editState && itemToEdit.EthnicGroupID == ethnic.EthnicGroupID
                ">
                <input *ngIf="!submitted || ethnicGroupForm.get('Year')?.valid" formControlName="Year" size="5"
                  maxlength="4" type="text" pattern="[0-9]*"
                  (blur)="onFieldBlur('Year')"
                  class="w-20 self-start rounded-lg border px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
                  [ngClass]="{
                    'bg-[#f8cfcffa]': isValueEmpty(ethnicGroupForm.get('Year')?.value),
                  }" />
                <div *ngIf="submitted && !ethnicGroupForm.get('Year')?.valid" data-tip="Enter a valid number">
                  <input type="text" pattern="[0-9]*" formControlName="Year" size="5" maxlength="4"
                    class="w-20 self-start rounded-lg border bg-[#f8cfcffa] px-1 py-1 text-end shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden" />
                </div>
                <span *ngIf="fieldErrors['Year']" class="mt-1 block text-sm text-cam-red">
                  {{ fieldErrors['Year'] }}
                </span>
              </td>

              <!-- Actions -->
              <td>
                <div class="flex flex-col gap-1 px-2 text-sm">
                  <button *ngIf="type == 'Future' && !editState"
                    class="rounded bg-cam-green p-1 leading-none text-white transition duration-100 hover:scale-105 hover:cursor-pointer"
                    type="button" (click)="makeCurrent(ethnic)">
                    Make Current
                  </button>
                  <button *ngIf="!editState" type="button"
                    class="rounded bg-blue-500 px-1 text-white transition duration-100 hover:scale-105 hover:cursor-pointer"
                    (click)="editItem(ethnic)">
                    Edit
                  </button>
                  <button *ngIf="ethnic.Action === 'U' && !editState" type="button"
                    class="rounded bg-cam-orange px-1 text-white transition duration-100 hover:scale-105 hover:cursor-pointer"
                    (click)="confirmItem(ethnic)">
                    No Change
                  </button>
                  <button *ngIf="!editState" type="button"
                    class="rounded bg-cam-red px-1 text-white transition duration-100 hover:scale-105 hover:cursor-pointer"
                    (click)="onDelete(ethnic)">
                    Delete
                  </button>
                  <button *ngIf="
                      editState &&
                      itemToEdit.EthnicGroupID == ethnic.EthnicGroupID
                    " [class]="
                      ethnicGroupForm.valid
                        ? 'rounded bg-cam-green px-1 text-white transition duration-100 hover:scale-105 hover:cursor-pointer'
                        : 'cursor-not-allowed rounded bg-zinc-300 px-1 text-white'
                    " [disabled]="!ethnicGroupForm.valid" type="submit">
                    Save
                  </button>
                  <button *ngIf="
                      editState &&
                      itemToEdit.EthnicGroupID == ethnic.EthnicGroupID
                    "
                    class="rounded bg-zinc-500 px-1 text-white transition duration-100 hover:scale-105 hover:cursor-pointer"
                    type="button" (click)="cancelDelete()">
                    Cancel
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </ng-container>
      </table>
    </div>
  </form>
  <div class="flex justify-center">
    <pagination-controls (pageChange)="onPageChange($event)"></pagination-controls>
  </div>
  <div class="flex justify-center">
    <button [class]="canNavigate()
          ? 'flex cursor-pointer justify-center rounded-lg bg-green-700 px-3 py-2 font-semibold text-green-100 outline-offset-2 transition hover:bg-green-600 active:bg-green-700 active:text-green-100/70 active:transition-none'
          : 'cursor-not-allowed justify-center rounded-lg bg-zinc-400 px-3 py-2 font-semibold text-zinc-100 outline-offset-2'"
      [disabled]="!canNavigate()" 
      (click)="onNavigate()">
      Save and Continue
    </button>
  </div>
</div>

<ng-template #noItems>
  <td colspan="8" class="text-center">
    <h5>There is no data to display!!</h5>
  </td>
</ng-template>